import { Component, Input } from "@angular/core";

import { NotificationType } from "@bitwarden/web-vault/app/models/types/confirmation.types";

// Derived so a new NotificationType fails to compile here until it has a config entry below.
export type StatusHeaderType = Exclude<NotificationType, "success">;

interface StatusHeaderIconConfig {
  iconName: string;
  bgClass: string;
  shadowClass: string;
  borderClass: string;
  textClass: string;
}

export const STATUS_HEADER_ICON_CONFIGS: Record<StatusHeaderType, StatusHeaderIconConfig> = {
  warning: {
    iconName: "alert-triangle",
    bgClass: "tw-bg-color-status-warning-bg",
    shadowClass: "tw-shadow-elevation-status-icon-warning",
    borderClass: "tw-border-color-status-warning-icon-border",
    textClass: "tw-text-color-status-warning-solid",
  },
  info: {
    iconName: "info-circle",
    bgClass: "tw-bg-color-status-info-bg",
    shadowClass: "tw-shadow-elevation-status-icon-info",
    borderClass: "tw-border-color-status-info-icon-border",
    textClass: "tw-text-color-status-info-text",
  },
  error: {
    iconName: "alert-circle",
    bgClass: "tw-bg-color-status-error-bg",
    shadowClass: "tw-shadow-elevation-status-icon-error",
    borderClass: "tw-border-color-status-error-icon-border",
    textClass: "tw-text-color-status-error-text",
  },
};

/**
 * Round icon badge + heading used at the top of a status-flavoured panel (a confirmation
 * dialog's warning/info/error variant, or a plain-div popover like the sign-up password note).
 * Extracted from ConfirmationDialogComponent — register-form.component.html had grown a
 * byte-identical copy of the warning variant (#4382).
 */
@Component({
  selector: "app-status-header",
  templateUrl: "./status-header.component.html",
  // Custom elements default to display: inline, which silently drops a consumer's own
  // margin/width utility classes (e.g. ConfirmationDialogComponent's tw-mb-4) since
  // margin-top/bottom has no effect on non-replaced inline elements.
  host: { class: "tw-block" },
})
export class StatusHeaderComponent {
  @Input({ required: true }) type: StatusHeaderType;
  @Input({ required: true }) title: string;

  get config(): StatusHeaderIconConfig {
    return STATUS_HEADER_ICON_CONFIGS[this.type];
  }
}
